import { render, staticRenderFns } from "./feedbackView.vue?vue&type=template&id=2d3d2ec7&scoped=true"
import script from "./feedbackView.vue?vue&type=script&lang=js"
export * from "./feedbackView.vue?vue&type=script&lang=js"
import style0 from "./feedbackView.vue?vue&type=style&index=0&id=2d3d2ec7&prod&lang=scss&scoped=true"
import style1 from "./feedbackView.vue?vue&type=style&index=1&id=2d3d2ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d2ec7",
  null
  
)

export default component.exports